module.exports = __webpack_public_path__ + "img/logo.b7f01707.png";